export enum RightColumnContent {
  ChatInfo,
}

export type ProfileTabType = 'members';
